import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { LogoutComponent } from './logout/logout.component';
import { DefaultComponent } from './pages/dashboards/default/default.component';
const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  // tslint:disable-next-line: max-line-length
  { path: '', 
    component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
  },
  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule)},
  { path: 'logout', component: LogoutComponent},
  { path: 'version', component: LogoutComponent},
  { path: '404', component: DefaultComponent },
  { path: '**',component: DefaultComponent}  
  // { path: 'dashboard', component: DefaultComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
